import { yupResolver } from "@hookform/resolvers/yup";
import { defaultFormValues as _defaultFormValues, schema } from "./constants";
import { TerminalFormValues } from "./types";
import { FormProvider, useForm } from "react-hook-form";

export interface TerminalFormProps {
  defaultFormValues?: Partial<TerminalFormValues>;
  children?: React.ReactNode;
}
export const TerminalForm = ({
  defaultFormValues,
  children,
}: TerminalFormProps) => {
  const methods = useForm<TerminalFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ..._defaultFormValues,
      ...defaultFormValues,
    },
    resolver: yupResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
